import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../utils/authService';

/**
 * /app/account
 *
 * Default landing for "Mi cuenta". Company admins land on /plan, employees on /profile,
 * super admins on /profile (they don't have personal billing).
 */
const AccountIndex = () => {
  const user = authService?.getCurrentUser();
  if (user?.role === 'company') {
    return <Navigate to="/app/account/plan" replace />;
  }
  return <Navigate to="/app/account/profile" replace />;
};

export default AccountIndex;
